import styled from 'styled-components';
import { themeOptions } from 'styles';

export const StyledStickyTable = styled.div`
  .MuiPaper-root {
    box-shadow: none;
    border-radius: 0;
    border-top: 1px solid #dadada;
  }
  //Table Header
  .MuiTableCell-head {
    height: 40px;
    padding: 5px 0;
    color: #222222;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-align: center;
    background-color: ${themeOptions.palette.gray.light};
  }

  .MuiTableRow-root {
    > td {
      white-space: break-spaces;
    }
  }

  //Table Body
  .MuiTableCell-body {
    height: 40px;
    padding: 5px 0;
    color: ${themeOptions.palette.gray.dark};
    text-align: center !important;

    &.new-cell {
      width: 100%;
      height: 40px;
      padding: 11px 16px !important;
      cursor: pointer;
      color: #adadad;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      text-align: left !important;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;

      &.border {
        border-bottom: 1px solid ${themeOptions.palette.gray.border};
      }
    }
  }

  .MuiTablePagination-root {
    border-bottom: none;
    padding: 0 !important;

    .MuiTablePagination-toolbar {
      padding: 0 !important;

      .MuiInputBase-root {
        margin-right: 0 !important;
        border-radius: 4px;
        border: 1px solid #dadada;
      }
    }
  }

  .MuiTablePagination-displayedRows {
    display: none;
  }

  .MuiTablePagination-actions {
    display: none;
  }

  .table-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;

    &.absolute-bottom {
      position: absolute;
      bottom: 50px;
      right: 10px;
    }

    &-select {
      display: flex;
      align-items: center;

      &-option {
        border-radius: 4px;
        border: 1px solid rgb(218, 218, 218);
        margin-right: 0px !important;
        margin-left: 12px;
        padding: 0;

        .MuiSelect-select {
          padding: 6px 30px 6px 16px;
        }
      }
    }
  }
`;

export const StyledStickyPagination = styled.div`
  .MuiTablePagination-input {
    margin-left: 12px;
    padding: 0;
    .MuiTablePagination-select {
      padding: 6px 30px 6px 16px;
    }
  }
  .MuiPaginationItem-text.Mui-selected {
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: ${themeOptions.palette.white.main};
    background-color: ${themeOptions.palette.green.main};
  }
`;
